import React from 'react';

// Fontawesome Imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faChalkboardTeacher,
	faLaptopCode,
	faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';

// Slider Imports
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Local Imports
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const AboutServicesList = () => {
	// Component Funtions
	const sliderSettings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		rows: 3,
		slidesPerRow: 2,
		autoplay: true,
		autoplaySpeed: 3500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					infinite: true,
					autoplay: false,
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
					autoplay: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesPerRow: 1,
					slidesToScroll: 1,
					arrows: false,
					autoplay: true,
					rows: 1,
				},
			},
		],
	};

	return (
		<Slider {...sliderSettings}>
			<Container className='my-3'>
				<Card className='' style={{ border: 'none' }}>
					<Row className='mx-0'>
						<Col md={5} className='text-center py-4 px-3'>
							<FontAwesomeIcon
								icon={faChalkboardTeacher}
								size='4x'
								color='#072379'
								className='mb-0'
							/>
						</Col>
						<Col className='justify-content-center text-center d-md-none'>
							<div className='d-flex justify-content-center'>
								<div className='divider' />
							</div>
						</Col>
						<Col md={7} className='custom-vertical-align px-0'>
							<Card.Body className='pl-md-0'>
								<Card.Text className='about-card-text px-3'>
									Contrucción <br />
									de Marca <br />
									Personal
								</Card.Text>
							</Card.Body>
						</Col>
					</Row>
				</Card>
			</Container>
			<Container className='my-3'>
				<Card className='' style={{ border: 'none' }}>
					<Row className='mx-0'>
						<Col md={5} className='text-center py-4 px-3'>
							<FontAwesomeIcon
								icon={faLaptopCode}
								size='4x'
								color='#072379'
								className='mb-0'
							/>
						</Col>
						<Col className='justify-content-center text-center d-md-none'>
							<div className='d-flex justify-content-center'>
								<div className='divider' />
							</div>
						</Col>
						<Col md={7} className='custom-vertical-align px-0'>
							<Card.Body className='pl-md-0'>
								<Card.Text className='about-card-text px-3'>
									Capacitación <br />
									Online <br />
									Ditáctica
								</Card.Text>
							</Card.Body>
						</Col>
					</Row>
				</Card>
			</Container>
			<Container className='my-3'>
				<Card className='' style={{ border: 'none' }}>
					<Row className='mx-0'>
						<Col md={5} className='text-center py-4 px-3'>
							<FontAwesomeIcon
								icon={faQuestionCircle}
								size='4x'
								color='#072379'
								className='mb-0'
							/>
						</Col>
						<Col className='justify-content-center text-center d-md-none'>
							<div className='d-flex justify-content-center'>
								<div className='divider' />
							</div>
						</Col>
						<Col md={7} className='custom-vertical-align px-0'>
							<Card.Body className='pl-md-0'>
								<Card.Text className='about-card-text px-3'>
									Consultoría <br />
									Profesional <br />
									Personalizada
								</Card.Text>
							</Card.Body>
						</Col>
					</Row>
				</Card>
			</Container>
			<Container className='my-3'>
				<Card className='' style={{ border: 'none' }}>
					<Row className='mx-0'>
						<Col md={5} className='text-center py-4 px-3'>
							<FontAwesomeIcon
								icon={faCalendarAlt}
								size='4x'
								color='#072379'
								className='mb-0'
							/>
						</Col>
						<Col className='justify-content-center text-center d-md-none'>
							<div className='d-flex justify-content-center'>
								<div className='divider' />
							</div>
						</Col>
						<Col md={7} className='custom-vertical-align px-0'>
							<Card.Body className='pl-md-0'>
								<Card.Text className='about-card-text px-3'>
									Flexibilidad de <br />
									Fechas y <br />
									Horarios
								</Card.Text>
							</Card.Body>
						</Col>
					</Row>
				</Card>
			</Container>
		</Slider>
	);
};

export default AboutServicesList;
